<template>
  <comment-bar-layout class="program-review-layout"
                      :show-bar="showBottomBar"
                      :placeholder="commentPlaceholder"
                      :comment.sync="commentContent"
                      :focus="commentFocus"
                      @comment="handleComment"
                      @page-click="handlePageClick"
  >
    <slot></slot>
  </comment-bar-layout>
</template>

<script>
  import CommentBarLayout from '@/layout/CommentBarLayout';
  import validator from '@/utils/validator';
  import { createAudioComment } from '@/services/comment';
  import { getUID } from '@/utils';

  export default {
    name: 'ProgramReviewLayout',
    components: {
      CommentBarLayout,
    },
    data() {
      return {
        commentPlaceholder: '优质评论将会被优先展示哦~',
        commentReplyId: 0,
        commentContent: '',
        commentFocus: false,
      };
    },
    props: {
      programId: {
        type: Number,
        required: true,
      },
      showBottomBar: {
        type: Boolean,
        required: true,
      },
      placeholder: {
        type: String,
        default: '优质评论将会被优先展示哦~',
      },
      replyReview: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      reviews: {
        type: Object,
        required: true,
      },
    },
    watch: {
      placeholder(val) {
        this.commentPlaceholder = val;
      },
      replyReview(val) {
        this.handleClickReply(val);
      },
    },
    methods: {
      resetComment() {
        this.commentContent = '';
        this.commentReplyId = 0;
      },
      handlePageClick() {
        if (this.commentReplyId > 0) {
          this.commentPlaceholder = '优质评论将会被优先展示哦~';
          this.resetComment();
        }
      },
      handleClickReply(review) {
        if (review.type === 'quote') return;
        if (review.id === 0) {
          this.$toast('找不到正确的评论');
          return;
        }
        const userId = getUID();
        if (parseInt(userId, 10) === parseInt(review.userId, 10)) {
          this.$toast('不可以回复自己的评论哦');
          return;
        }
        this.commentPlaceholder = `回复：${review.name}`;
        this.commentReplyId = review.id;
        this.commentFocus = true;
      },
      async handleComment(content) {
        if (validator.isEmpty(content)) {
          this.$toast('请输入内容');
          return;
        }
        const data = await createAudioComment({
          programId: this.programId,
          content,
          replyId: this.commentReplyId,
        });
        this.reviews.list = [data, ...this.reviews.list];
        this.reviews.start = this.reviews.start + 1;
        this.reviews.count = this.reviews.count + 1;
        this.commentPlaceholder = '优质评论将会被优先展示哦~';
        this.resetComment();
      },
    },
    created() {
      this.commentPlaceholder = this.placeholder;
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

</style>
